import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { Routes } from '@/router';
import { AnalyticsEventCategory, AnalyticsEventAction, AnalyticsEventLabel } from '@/services/google/google-analytics.services';

@Component({
    name: 'CmgChipotleUAccountModalRewardsActions'
})

export default class CmgChipotleUAccountModalRewardsActions extends Vue {
    get bagIcon(): string {
        return this.$appStore.state.cms.images.loyalty.bagIcon.default;
    }

    get guacIcon(): string {
        return this.$appStore.state.cms.images.loyalty.guacIcon.default;
    }

    get boltIcon(): string {
        return this.$appStore.state.cms.images.loyalty.boltIcon.default;
    }

    close() {
        this.$services.ui.setModalVisibility('account', false);
        this.$services.ui.focusBack();
    }

    get numRewards(): number {
        return this.$services.reward.getNumRedeemableRewards();
    }

    get numPromotions(): number {
        return this.$appStore.state.customer.wallet.promotions.length;
    }

    get numCampaigns(): number {
        return this.$appStore.state.reward.campaigns.length;
    }

    onClickRewardsExchange() {
        this.$services.googleAnalytics.sendCustomEvent({
            category: AnalyticsEventCategory.RewardsAccount,
            action: AnalyticsEventAction.RewardExchangeClick,
            label: AnalyticsEventLabel.RewardsRewardExchangeClick,
        });
        this.$router.push({ name: Routes.RewardsExchange });
        this.close();
    }

    onClickRewardsHome() {
        this.$services.googleAnalytics.sendCustomEvent({
            category: AnalyticsEventCategory.RewardsAccount,
            action: AnalyticsEventAction.RewardBonusClick,
            label: AnalyticsEventLabel.RewardBonusClick,
        });
        this.$router.push({ name: Routes.Rewards });
        this.close();
    }

    onClickRewardsExtras() {
        this.$router.push({ name: Routes.RewardsExtras });
        this.close();
    }
}